import React, { FC, memo } from 'react';
import styles from './m20categories.module.css';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import { M20CategoriesModule } from '~/lib/data-contract';
import { getContrastColor, isDarkColor } from '~/themes/cms-color-helpers';
import M20category from './m20category/m20category.component';
import { Typography } from '~/shared/components';
import clsx from 'clsx';
import { queries } from '~/theme';

const getImageSizes = (columnsCount = 1) => {
    switch (columnsCount) {
        case 1:
            return `${queries.belowSm} 100vw, 100vw`;
        case 2:
            return `${queries.belowSm} 100vw, ${queries.belowLg} 50vw, 50vw`;
        case 3:
            return `${queries.belowSm} 100vw, ${queries.belowLg} 33vw, 33vw`;
        case 4:
        default:
            return `${queries.belowSm} 100vw, ${queries.belowLg} 25vw, 25vw`;
    }
};

const M20TestComponent: FC<M20CategoriesModule> = (props) => {
    const { items = [], headline, headlineAlignment = 'left', backgroundColor, ...rest } = props;

    const itemsLength = items?.length || 0;

    const columnsCount = itemsLength > 4 ? 4 : itemsLength;

    const imageSizes = getImageSizes(columnsCount);

    const isDarkShade = isDarkColor(backgroundColor || '');
    const contrastBackgroundColor = getContrastColor(backgroundColor);

    return (
        <ModuleContainer hasGutter backgroundColor={backgroundColor} {...rest}>
            {headline && (
                <Typography
                    className={styles.title}
                    as="h2"
                    variant="display2"
                    textAlign={headlineAlignment}
                    isDarkBackground={isDarkShade}
                >
                    {headline}
                </Typography>
            )}
            {itemsLength > 0 && (
                <section className={clsx(styles.grid, styles[`columns${columnsCount}`])}>
                    {[...items]?.map((item, index) => (
                        <M20category
                            key={`${(item as any)?.id}-${index}`}
                            item={item}
                        isDarkShade={isDarkShade}
                        backgroundColor={contrastBackgroundColor}
                        imageSizes={imageSizes}
                    />
                ))}
            </section>
            )}
        </ModuleContainer>
    );
};

const M20Test = memo(M20TestComponent);

M20Test.displayName = 'M20Test';

export default M20Test;
